module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// ./~/ripemd160/~/readable-stream/lib/internal/streams/stream-browser.js
// module id = 372
// module chunks = 42